import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import UseAnimations from 'react-useanimations';
import { Icon, Button, IconButton, Fab } from "@material-ui/core";
import { Breadcrumb, SimpleCard } from "matx";

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1)
  },
  input: {
    display: "none"
  }
}));

export default function AnimationIcons(props) {
  const classes = useStyles();
  const {iconType}=props;

  return (
     <UseAnimations animationKey={iconType} size={18} style={{color:"#00c853"}} />
  );
}
